import React from "react";

import Page from "../../../../components/Page";
import Header from "../../../../components/Header";
import PageHeaderBanner from "../../../../sections/layouts/pageHeaderBanner";
import Section from "../../../../sections/layouts/section";
import Footer from "../../../../components/Footer";
import Custom_a from "../../../../sections/layouts/custom_a";
import Image from "../../../../components/Image";
import VerticalTickBox from "../../../../sections/layouts/verticalTickBox";
import ColumnInfoBox from "../../../../sections/layouts/columnInfoBox";

import xero_banner from "../images/xero/small-business-integrations.jpg";
import xero_stand from "../images/xero/pos_xero.png";

import xeroBannerLogo from "../images/xero/logo_xero.png";
import SEOInfo from "../../../../components/SEOInfo";

const headerBannerProps = {
  pageSubheader: "Xero + Yoco",
  textColor: "black",
  bgColor: "#f6f6f6",
  pageText: (
    <p>
      Automatic daily sales update and an up-to-date financial view of your
      business. <br /> All seamless and in the cloud.
    </p>
  )
};

const tickBox = [
  "Xero is easy to use online accounting software that’s designed specifically for small businesses",
  "It's all online, so you can work when and where you want to. Just login with your PC, Mac or mobile",
  "Your bank statements are automatically imported and categorized, letting you see your cashflow in real time",
  "Invite your team and work together on financials. You can collaborate over your up to date numbers",
  "Xero has all you need to run your business – including invoicing, paying bills, sales tax returns, reporting and much more"
];

const costInfo = [
  {
    heading: "Complete mobility",
    paragraph:
      "Run your business from anywhere with Xero's cloud-based tracking and Yoco's mobile point of sale."
  },
  {
    heading: `Easy Recons`,
    paragraph:
      "All transactions from Yoco are fed and matched into Xero automatically. No more manual data entry - you won't know what to do with all your free time!"
  },
  {
    heading: `Real-time tracking`,
    paragraph:
      "All statements are at your fingertips and always up to date. Xero converts the Yoco daily summary into an invoice with sales, tips, fees and a tax breakdown."
  }
];

const IndexPage = props => {
  const { location } = props;
  return (
    <Page>
      <SEOInfo
        title={"Xero"}
        description={""}
        canonicalLink={location.pathname}
      />
      <Header />
      <PageHeaderBanner pageLogo={xeroBannerLogo} {...headerBannerProps} />
      <Section className={"pt-4 pb-0"}>
        <div className={"container"}>
          <div className={"row"}>
            <ColumnInfoBox
              data={costInfo}
              headerStyle={{ fontWeight: "bold" }}
            />
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-12 pt-4"}>
            <img src={xero_banner} alt={"could not load image"} />
          </div>
        </div>
      </Section>
      <Section textAlign="left">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-md-6"}>
              <h2>PARTNER FEATURES</h2>
              <h3 className={"pr-0"}>What is Xero?</h3>
              <VerticalTickBox
                data={tickBox}
                tickStyle={{ marginTop: "35px", marginLeft: "7px" }}
              />
            </div>
            <div className={"col-md-6 plr-md-5"}>
              <Image src={xero_stand} />
            </div>
          </div>
        </div>
      </Section>
      <Section bgColor="#DEE6E9">
        <Custom_a />
      </Section>

      <Footer />
    </Page>
  );
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/za/integrations/xero/index.js